import { render, staticRenderFns } from "./PublishShiftAvailability.vue?vue&type=template&id=0f3fe003&scoped=true"
import script from "./PublishShiftAvailability.vue?vue&type=script&lang=js"
export * from "./PublishShiftAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3fe003",
  null
  
)

export default component.exports